var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInterests(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 27.5H8.5C7.96957 27.5 7.46086 27.2893 7.08579 26.9142C6.71071 26.5391 6.5 26.0304 6.5 25.5V7.5C6.5 6.96957 6.71071 6.46086 7.08579 6.08579C7.46086 5.71071 7.96957 5.5 8.5 5.5H20.5C21.0304 5.5 21.5391 5.71071 21.9142 6.08579C22.2893 6.46086 22.5 6.96957 22.5 7.5V15.5",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8609 20.1313C25.6311 19.9056 25.3545 19.7331 25.0506 19.626C24.7468 19.519 24.4231 19.4799 24.1026 19.5117C23.782 19.5435 23.4723 19.6452 23.1953 19.8098C22.9184 19.9745 22.681 20.1979 22.4999 20.4643C22.3188 20.1979 22.0815 19.9745 21.8045 19.8098C21.5276 19.6452 21.2179 19.5435 20.8973 19.5117C20.5767 19.4799 20.2531 19.519 19.9492 19.626C19.6454 19.7331 19.3688 19.9056 19.1389 20.1313C18.9366 20.3302 18.7759 20.5674 18.6662 20.8291C18.5565 21.0907 18.5 21.3716 18.5 21.6553C18.5 21.939 18.5565 22.2199 18.6662 22.4816C18.7759 22.7432 18.9366 22.9804 19.1389 23.1793L22.4999 26.5003L25.8609 23.1793C26.0633 22.9804 26.224 22.7432 26.3337 22.4816C26.4434 22.2199 26.4999 21.939 26.4999 21.6553C26.4999 21.3716 26.4434 21.0907 26.3337 20.8291C26.224 20.5674 26.0633 20.3302 25.8609 20.1313V20.1313Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterests);
export default __webpack_public_path__ + "static/media/Interests.b9dd547337b8e559fddf1f16c56248fb.svg";
export { ForwardRef as ReactComponent };